import { Link } from 'react-router-dom';
import '../styles/inner.css';

const sideLinks = [
  { label: 'Services', active: true },
  { label: 'Credit Rating' },
  { label: 'Individual credit rating.', sub: true },
  { label: 'SMEs Rating.', sub: true },
  { label: 'Business Prospects Validation :' },
  { label: 'Vendors / Suppliers rating.', sub: true },
  { label: "Key customer 's rating.", sub: true },
  { label: 'Property validation.', sub: true },
  { label: 'Prospective Tenant Verification.', sub: true },
  { label: 'Employee Credentials Check :' },
  { label: 'Pre and Post Employment', sub: true },
  { label: 'Validation Services.', sub: true },
  { label: 'Specialised Data Validation Services.', sub: true },
  { label: 'Royalty / Retention Services :' },
  { label: "Customer's Satisfaction/", sub: true },
  { label: 'Feedback Surveys .', sub: true },
  { label: 'Pre Product launch Surveys .', sub: true },
  { label: 'Complaint Resolution Services', sub: true },
];

const circleStyle = {
  width: '200px',
  height: '200px',
  borderRadius: '50%',
  border: '3px solid #eee',
  overflow: 'hidden',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#f0f0f0',
  flexShrink: 0,
};

const imgStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
  borderRadius: '50%',
};

export default function Services() {
  return (
    <>
      <div className="inner-banner services" style={{ backgroundImage: "url('/images/Slide2.jpg')" }}>
        <div className="container">
          <h1>Services</h1>
          <div className="sep" />
          <h4>Matrix Processing House</h4>
        </div>
      </div>

      <div className="inner-bottom-sec">
        <div className="container">
          <div className="side-menu">
            <ul>
              {sideLinks.map((l, i) => (
                <li key={i} className={`${l.active ? 'active' : ''} ${l.sub ? 'sub-item' : ''}`}>
                  {l.label}
                </li>
              ))}
            </ul>
          </div>

          <div className="inner-main-part">
            <div className="inner-tp-dis">
              <h3>Services</h3>
              <p>We deliver professional, ethical debt-collection solutions that help businesses recover outstanding payments while preserving positive customer relationships. Our services fully comply with applicable laws and emphasize respectful communication, transparency, and measurable results.</p>
              <p style={{ marginLeft: 10 }}>
                - Commercial and consumer debt recovery<br/>
                - Fully compliant, lawful collection practices<br/>
                - Confidential and secure data handling<br/>
                - Customized recovery strategies tailored to your business<br/>
                - No harassment or unethical collection methods
              </p>
            </div>

            {/* HUMAN RESOURCES */}
            <div className="overviw-bx">
              <div className="content-lft">
                <h2>Human <span>Resources</span></h2>
                <p>Credit Rating :<br/>Individual credit rating.<br/>SMEs Rating.<br/>Life style analysis for Cash Flow Estimation.</p>
              </div>
              <div className="content-rgt">
                <div className="content-img-circle" style={circleStyle}>
                  <img src="/images/overview-img1.png" alt="Human Resources" style={imgStyle} />
                </div>
              </div>
            </div>

            {/* BUSINESS PROSPECTS */}
            <div className="overviw-bx reverse">
              <div className="content-lft">
                <h2>Business <span>Prospects</span></h2>
                <p>Business Prospects Validation<br/>Vendors / Suppliers rating.<br/>Key customer 's rating.<br/>Property validation.<br/>Prospective Tenant Verification.</p>
              </div>
              <div className="content-rgt">
                <div className="content-img-circle" style={circleStyle}>
                  <img src="/images/overview-img2.png" alt="Business Prospects" style={imgStyle} />
                </div>
              </div>
            </div>

            {/* EMPLOYEE CREDENTIALS */}
            <div className="overviw-bx">
              <div className="content-lft">
                <h2>Employee <span>Credentials</span></h2>
                <p>Employee Credentials Check :<br/>Pre and Post Employment Validation Services.<br/>Specialised Data Validation Services.</p>
              </div>
              <div className="content-rgt">
                <div className="content-img-circle" style={circleStyle}>
                  <img src="/images/overview-img3.png" alt="Employee Credentials" style={imgStyle} />
                </div>
              </div>
            </div>

            {/* BUSINESS PRACTICE */}
            <div className="overviw-bx reverse">
              <div className="content-lft">
                <h2>Business <span>Practice</span></h2>
                <p>Royalty / Retention Services :<br/>Customer's Satisfaction/ Feedback Surveys .<br/>Pre Product launch Surveys .<br/>Complaint Resolution Services</p>
              </div>
              <div className="content-rgt">
                <div className="content-img-circle" style={circleStyle}>
                  <img src="/images/overview-img4.png" alt="Business Practice" style={imgStyle} />
                </div>
              </div>
            </div>

            {/* OUR QUALITY */}
            <div className="overviw-bx">
              <div className="content-lft">
                <h2>Our <span>Quality</span></h2>
                <p>Banking Information Services :<br/>Stock / Debtors Validation ..<br/>Property Validation .<br/>Asset Sighting Services .</p>
              </div>
              <div className="content-rgt">
                <div className="content-img-circle" style={circleStyle}>
                  <img src="/images/overview-img5.png" alt="Our Quality" style={imgStyle} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
